export const customerDetailsFormFields = [
  {
    type: 'text',
    name: 'fullName',
    label: "Customer's Name",
    placeholder: 'Eg: Aman Singh',
    config: {
      required: true,
    },
  },
  {
    type: 'text',
    name: 'email',
    label: "Customer's Email ID",
    placeholder: 'Eg: username@gmail.com',
    config: {
      required: true,
    },
  },
  {
    type: 'phoneNumber',
    name: 'phoneNumber',
    label: "Customer's Phone Number",
    placeholder: '999 999 999',
    config: {
      required: true,
    },
    editable: true,
  },
  {
    type: 'number',
    name: 'pinCode',
    label: "Customer's PIN Code",
    placeholder: 'Eg: 560035',
    iconLeft: 'LocationPointerOutlined',
    maxLength: 6,
    config: {
      required: true,
    },
  },
  {
    type: 'dropDown',
    name: 'employmentType',
    label: "Customer's Employment Type",
    placeholder: 'Eg: Self Employed',
    dropOptions: [
      {
        key: 0,
        optionId: 'Self-Employed',
        optionValue: 'Self-Employed',
      },
      {
        key: 1,
        optionId: 'Salaried',
        optionValue: 'Salaried',
      },
      {
        key: 3,
        optionId: 'Business Owner',
        optionValue: 'Business Owner',
      },
      {
        key: 4,
        optionId: 'Not Working',
        optionValue: 'Not Working',
      },
    ],
    isSearchable: false,
    config: {
      required: true,
    },
  },
  {
    type: 'toggle',
    name: 'modeOfIncome',
    label: "Customer's Income Mode",
    fieldOptions: [
      {
        id: '1',
        key: 'BANK',
        optionId: 'BANK',
        optionValue: 'Bank Account',
        icon: 'BankIcon',
      },
      {
        id: '2',
        key: 'CASH',
        optionId: 'CASH',
        optionValue: 'Cash',
        icon: 'CurrencyIcon',
      },
    ],
    config: {
      required: true,
    },
  },
  {
    type: 'number',
    name: 'annualIncome',
    label: "Customer's Monthly Income",
    placeholder: 'Eg: ₹15,000',
    iconLeft: 'RupeeCircleOutlined',
    config: {
      required: true,
    },
  },
]
